<template>
  <!--<a :href="tool.website" target="_blank" v-if="tool.website !== undefined">-->
  <a
    class="hovercard"
    target="_blank"
    v-if="tool.website !== undefined"
    :class="$store.state.screenMode === 'dark' ? 'dark' : ''"
  >
    <div
      class="itemContainer"
      :style="`height:450px; background:url('${tool.websitePreview}'); background-size:contain;`"
    >
      <a :href="tool.website" target="_blank">
        <!-- <img v-if="tool.websitePreview" class="websitePreview"
          :src="tool.websitePreview" /> -->
      </a>
      <!-- <img class="websitePreview" v-if="tool.websitePreview === undefined"
        src="https://cdn.discordapp.com/attachments/772789919122325515/948915936818233414/banner.webp" /> -->
      <div class="textcontainer">
        <div class="d-flex justify-content-between">
          <a style="margin: auto" :href="tool.website" target="_blank">
            <h5>{{ tool.title }}</h5>
          </a>
          <div class="imgContainer">
            <a :href="tool.website" v-if="tool.logo" target="_blank">
              <img
                v-if="tool.logo"
                :src="tool.logo"
                class="rounded-circle toolwebsitelogo"
                :alt="tool.title"
            /></a>
            <button
              style="border-radius: 15px"
              v-if="!isFavorite(tool)"
              class="favorite"
              @click="addFavorite(tool)"
            >
              <img class="star" src="@/assets/ster-outline.svg" />
              <!-- <i class="fa-light fa-star"></i> -->
            </button>
            <button
              style="border-radius: 15px"
              v-if="isFavorite(tool)"
              @click="removeFavorite(tool)"
              class="favorite"
            >
              <img class="star-filled" src="@/assets/ster-ingevuld-v2.svg" />
              <!-- <i class="fa-solid fa-star"></i> -->
            </button>
          </div>
        </div>
        <p>{{ tool.description }}</p>
      </div>
    </div>
  </a>
</template>

<script>
import { useMessage } from "naive-ui";
export default {
  name: "ItemTemplate",
  props: {
    tool: Object,
  },
  setup() {
    window.$message = useMessage();
  },
  computed: {
    userUID() {
      return this.userObj
        ? this.$store.state.userObj.uid
        : localStorage.getItem("uid");
    },
    userObj() {
      return this.$store.state.userObj;
    },
    favTools() {
      return this.$store.state.favoriteTools;
    },
  },
  methods: {
    isFavorite(tool) {
      if (this.$store.state.favoriteTools.length <= 0) {
        return false;
      }
      for (let currentTool of this.$store.state.favoriteTools) {
        if (currentTool.title == tool.title) {
          return true;
        }
      }
    },
    addFavorite(tool) {
      if (this.$store.state.isLoggedIn) this.$store.dispatch("addTool", tool);
      else {
        alert("Log in first to add this tool to favorites");

        //TODO: Fix this
        window.$message.error("Log in first to add this tool to favorites", {
          keepAliveOnHover: true,
        });
      }
    },
    async removeFavorite(tool) {
      await this.$store.dispatch("removeTool", tool);

      //BAD SOLUTION
      setTimeout(() => {
        let categoryTitle = document.getElementsByTagName("h5")[0];
        if (categoryTitle !== undefined) {
          if (categoryTitle.innerText.toLowerCase() === "favorite tools") {
            let allExtraBtns = document.querySelectorAll(
              "button.btn.extraBtns"
            );
            for (let btn of allExtraBtns) {
              if (btn !== undefined) {
                if (btn.innerText.toLowerCase() === "dashboard") {
                  setTimeout(() => {
                    btn.click();
                  }, 500);
                }
              }
            }
          }
        }
      }, 250);
    },
  },
};
</script>

<script setup>
function createId() {
  let length = 10;
  let id = "";
  let characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    id += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return id;
}

let id = createId();
</script>

<style scoped>
/*Dark mode */
.dark .textcontainer,
.dark .textcontainer h5 {
  color: white;
  background-color: var(--yungo-darkmode-background);
}

.dark .toolwebsitelogo {
  background: white;
}

/* */
.star,
.star-filled {
  margin-top: -3px;
}

.favorite {
  width: 40px;
  height: 40px;
  background-color: var(--yungo-lighter-purple);
  outline: none;
  border: none;
}

a {
  color: inherit;
  text-decoration: none !important;
}

.hovercard {
  flex: 1 0 200px;
}

.hovercard:hover {
  text-decoration: none;
  color: black;
  margin-top: -5px;
  filter: drop-shadow(0 0 2px lightgray);
}

.websitePreview {
  width: 270px;
  height: 170px;
  align-self: center;
  margin-bottom: 20px;
  border-radius: 15px;
  object-fit: cover;
}

/* .textcontainer div {
  padding-bottom: 10px;
} */
.textcontainer {
  border-radius: 30px;
  width: 310px;
  height: 190px;
}

.textcontainer div a {
  margin: 0 !important;
}

p {
  font-size: 13px;
  /* padding-right: 25px; */
  padding-bottom: 27px;
  /* padding-top: 20px; */
}

.imgContainer {
  display: flex;
}

.imgContainer button {
  margin-bottom: auto;
  background-color: var(--yungo-lighter-purple);
  margin-left: 13px;
}

.toolwebsitelogo {
  height: 40px;
  width: 40px;
  object-fit: cover;
}

.itemContainer {
  margin-right: 32px;
  width: 310px;
  max-height: 380px;
  border-radius: 30px;
  background-color: #ffffff;
  padding-top: 25px;
  height: fit-content;
  margin-top: 39px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.itemContainer a {
  margin: auto;
}

h5 {
  height: 52px;
  color: #070014;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 26px;
  margin-top: auto;
  margin-bottom: auto;
  width: 100%;
  word-break: break-word;
}

.textcontainer {
  padding-left: 25px;
  padding-right: 25px;
  flex-basis: fit-content;
  background: white;
}

.textcontainer div:first-child {
  margin-top: 15px;
  padding-bottom: 10px;
}

/* .textcontainer a {
  width: 50%;
} */
.imgContainer button i {
  margin-left: -2px;
}

@media only screen and (max-width: 1034px) {
  .itemContainer {
    width: inherit !important;
    height: auto !important;
    justify-content: inherit !important;
    padding: 0px !important;
    flex-direction: row;
    margin-right: 0;
  }

  .textcontainer {
    flex-basis: inherit !important;
  }
  .websitePreview {
    margin-left: 20px;
    width: 350px;
  }
}

@media only screen and (max-width: 900px) {
  .gridlayout {
    display: grid;
  }

  .textcontainer {
    flex-basis: fit-content !important;
    margin-left: 20px;
    margin-left: 30vw;
  }
  .websitePreview {
    margin-bottom: 0;
  }
}

@media only screen and (max-width: 700px) {
  .itemContainer {
    display: flex;
    flex-direction: column;
    padding: 0px !important;
    height: 450px !important;
  }

  .websitePreview,
  .itemContainer,
  .textcontainer {
    width: 100%;
  }

  h5,
  p {
    font-size: smaller !important;
    padding-top: 10px;
    padding-right: 0;
  }

  h5 {
    width: 100%;
  }
  .textcontainer {
    margin-left: 0;
  }
}
</style>